// extracted by mini-css-extract-plugin
export default {"heading":"JI","container":"KI","product_section_row":"LI","carousel":"MI","carouselwide":"NI","carouselwrapper":"OI","blockwrapper":"PI","product_carousel_row":"QI","headingnarrow":"RI","title":"SI"};
    if(module.hot) {
      // 1713912566145
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  